import React from 'react';
// React Helmet not used to avoid dependency bloat. Script tag renders in body (valid for Google).

// Content defined directly to ensure stability
const faqData = [
    {
        question: "Was ist das VANITY Magazin?",
        answer: "VANITY ist Österreichs führendes Premium-Magazin für ästhetische Medizin, Schönheit, Gesundheit und exklusiven Lifestyle. Wir verbinden medizinische Expertise mit High-End-Lifestyle."
    },
    {
        question: "Wo ist das VANITY Magazin erhältlich?",
        answer: "Das Magazin ist im ausgewählten Zeitschriftenhandel in Österreich, in exklusiven Arztpraxen, Spas und Hotels sowie digital auf vanity.co.at verfügbar."
    },
    {
        question: "Wie oft erscheint VANITY?",
        answer: "VANITY erscheint saisonal als hochwertiges Glossy-Magazin und bietet begleitend tägliche Updates und exklusive Storys online."
    }
];

// Medical procedures featured in VANITY content
const medicalProcedures = [
    {
        name: "Ästhetische Dermatologie",
        description: "Umfassende Berichterstattung über ästhetische dermatologische Behandlungen, von Anti-Aging bis Hautverjüngung",
        procedureType: "Cosmetic",
        bodyLocation: "Gesicht, Haut"
    },
    {
        name: "Plastische Chirurgie",
        description: "Expertenwissen über plastisch-chirurgische Eingriffe und minimal-invasive Verfahren",
        procedureType: "Surgical",
        bodyLocation: "Gesicht, Körper"
    },
    {
        name: "Anti-Aging Therapien",
        description: "Moderne Anti-Aging-Behandlungen: Botox, Filler, Laserbehandlungen und regenerative Medizin",
        procedureType: "Cosmetic",
        bodyLocation: "Gesicht, Hals, Décolleté"
    },
    {
        name: "Ästhetische Zahnmedizin",
        description: "Trends und Innovationen in der ästhetischen Zahnheilkunde für ein strahlendes Lächeln",
        procedureType: "Dental",
        bodyLocation: "Zähne, Kieferbereich"
    }
];

const StructuredData: React.FC = () => {
    const schema = {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": ["Organization", "MedicalBusiness"],
                "@id": "https://vanity.co.at/#organization",
                "name": "VANITY Magazin",
                "legalName": "VANITY Magazin",
                "url": "https://vanity.co.at",
                "logo": "https://vanity.co.at/public/vanity_logo500.jpg",
                "description": "VANITY ist an Austrian beauty, health and lifestyle glossy magazine covering trends, culture and personal well-being for modern readers.",
                "medicalSpecialty": ["Dermatology", "PlasticSurgery", "Cosmetic"],
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "Bankgasse 3/10",
                    "addressLocality": "Vienna",
                    "addressRegion": "Vienna",
                    "postalCode": "1010",
                    "addressCountry": "AT"
                },
                "contactPoint": {
                    "@type": "ContactPoint",
                    "telephone": "+43 676 1234567",
                    "contactType": "customer service",
                    "email": "info@vanity.co.at"
                },
                "sameAs": [
                    "https://www.facebook.com/vanitymagazin",
                    "https://www.instagram.com/vanitymagazin.vienna"
                ]
            },
            {
                "@type": "WebSite",
                "name": "VANITY Magazin",
                "url": "https://vanity.co.at",
                "potentialAction": {
                    "@type": "SearchAction",
                    "target": {
                        "@type": "EntryPoint",
                        "urlTemplate": "https://vanity.co.at/?s={search_term_string}"
                    },
                    "query-input": "required name=search_term_string"
                }
            },
            {
                "@type": "FAQPage",
                "mainEntity": faqData.map(item => ({
                    "@type": "Question",
                    "name": item.question,
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": item.answer
                    }
                }))
            },
            // Medical Procedures for SEO Enhancement
            ...medicalProcedures.map(procedure => ({
                "@type": "MedicalProcedure",
                "name": procedure.name,
                "description": procedure.description,
                "procedureType": procedure.procedureType,
                "bodyLocation": procedure.bodyLocation,
                "provider": {
                    "@id": "https://vanity.co.at/#organization"
                }
            })),
            // Editorial Services
            {
                "@type": "Service",
                "serviceType": "Redaktionelle Dienstleistungen",
                "name": "VANITY Magazin Content & Editorial",
                "description": "Hochwertige redaktionelle Berichterstattung über Ästhetik, Medizin, Gesundheit und Lifestyle",
                "provider": {
                    "@id": "https://vanity.co.at/#organization"
                },
                "areaServed": {
                    "@type": "Country",
                    "name": "Austria"
                },
                "availableChannel": {
                    "@type": "ServiceChannel",
                    "serviceUrl": "https://vanity.co.at"
                }
            }
        ]
    };

    return (
        <script type="application/ld+json">
            {JSON.stringify(schema)}
        </script>
    );
};

export default StructuredData;
